import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { UserInfoService } from '@ecap3/core';
import { IDetailsTabConfig, ISharedPerson } from '../../../../interface/document.manager.interface';
import { DriveFile } from '../../../../models/DriveFile';
import { DriveFolder } from '../../../../models/DriveFolder';
import { ObjectArtifact } from '../../../../models/ObjectArtifact.model';
import { DocumentManagerService } from '../../../../services/document-manager.service';
import { Subject, Observable, from, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-details-tab',
    templateUrl: './details-tab.component.html',
    styleUrls: ['./details-tab.component.scss']
})
export class DetailsTabComponent implements OnInit, OnDestroy {
    @Input() detailsConfig: IDetailsTabConfig;
    @Input() poweruser: boolean;
    Content: DriveFolder | DriveFile = null;
    ContentAsObjectArtifact: ObjectArtifact;
    onShowSubscription: Subscription;
    public sharedPersonList: ISharedPerson[] = [];
    public shareRoleList: any = [];
    private roles = [];

    private _unsubscribeAll: Subject<any> = new Subject();

    constructor(
        private documentManagerService: DocumentManagerService,
        @Inject('IDocumentManager') private IDocumentManager,
        private userInfoService: UserInfoService
    ) {}

    ngOnInit(): void {
        if (this.detailsConfig && this.detailsConfig.rolesList) {
            this.roles = this.detailsConfig.rolesList;
        }

        this.onShowSubscription = this.documentManagerService.onShowDetail
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((Content) => {
                this.Content = Content;
                this.sharedPersonList = [];
                this.shareRoleList = [];

                if (Content) {
                    this.handleContent();
                }
            });
    }

    private handleContent(): void {
        this.documentManagerService.GetObjectArtifactById(this.Content).then(res => {
            if (res && res.length > 0) {
                this.ContentAsObjectArtifact = res[0];

                // if(res[0].PowerUserSharedInfoList){
                //     let resPower = res[0].PowerUserSharedInfoList.filter( r => {
                //         if(r.PowerUserId === this.userInfoService.userInfo.UserId){return r}
                //     })[0];
                //     if(resPower && resPower.SharedPersonIdList.length>0){
                //         this.documentManagerService.GetPersonsByIds(resPower.SharedPersonIdList).then(resp => {
                //             this.sharePersonList = resp;
                //         }, error => {
                //             console.log(error);
                //         });
                //         if (this.detailsConfig && this.detailsConfig.dynamicRoleCallback) {
                //             this.IDocumentManager.getUserRolesName(resPower.SharedRoleList).subscribe((res: any) => {
                //                 this.shareRoleList = res;
                //             })
                //         } else {
                //             this.shareRoleList = resPower.SharedRoleList;
                //         }
                //     }
                // }
                // if (res[0].PowerUserSharedInfoList && res[0].PowerUserSharedInfoList.length > 0 && res[0].PowerUserSharedInfoList[0].SharedPersonIdList.length>0) {
                //     this.documentManagerService.GetPersonsByIds( res[0].PowerUserSharedInfoList[0].SharedPersonIdList).then(resp => {
                //         this.sharePersonList = resp;
                //     }, error => {
                //         console.log(error);
                //     });
                //     if (this.detailsConfig && this.detailsConfig.dynamicRoleCallback) {
                //         this.IDocumentManager.getUserRolesName(res[0].PowerUserSharedInfoList[0].SharedRoleList).subscribe((res: any) => {
                //             this.shareRoleList = res;
                //         })
                //     } else {
                //         this.shareRoleList = res[0].PowerUserSharedInfoList[0].SharedRoleList;
                //     }
                // }

                if (res[0].SharedPersonIdList && res[0].SharedPersonIdList.length > 0) {
                    this.getPersonData(res[0]);
                }
                
                if (res[0].SharedRoleList && res[0].SharedRoleList.length > 0) {
                    this.handleSharedRole(res[0].SharedRoleList);
                }
            }
        });
    }

    private handleSharedRole(sharedRoleList): void {
        if (this.detailsConfig && this.detailsConfig.dynamicRoleCallback) {
            this.IDocumentManager.getUserRolesName(sharedRoleList)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe((res: any) => {
                    this.shareRoleList = res;
                });
        } else {
            this.shareRoleList = sharedRoleList;
        }
    }

    private getPersonData(data): void {
        const getPersonNameCall: Observable<ISharedPerson[]> =
            this.detailsConfig && this.detailsConfig.dynamicPersonsCallback
                ? this.IDocumentManager.getPersonsDisplayName(data)
                : from(
                      this.documentManagerService.GetPersonsByIds(
                          data.SharedPersonIdList
                      )
                  );

        getPersonNameCall
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((response) => {
                response.forEach((sharedPerson) => {
                    if (!sharedPerson.ColorCode) {
                        sharedPerson.ColorCode =
                            this.documentManagerService.GetRandomColor();
                    }
                    sharedPerson.TextColorCode =
                        this.documentManagerService.GetTextColorFromBgColor(
                            sharedPerson.ColorCode
                        );
                });
                this.sharedPersonList = response;
            });
    }

    ngOnDestroy() {
        if(this.onShowSubscription)this.onShowSubscription.unsubscribe();
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    roleViewValue(role: string) {
        const r = this.roles.filter(obj => obj.Value === role)[0];
        if (r) {
            return r.ViewValue;
        }
        return role;
    }
}
